/**
 * Validation Rules of Vue-Form-Builder
 * - label: Human wording shown in the builder's rule dropdown. The KEY stays the stored
 *          value, so saved forms and anything keyed on the value are unaffected.
 * - desc: Validation Rule Info
 * - needValue - boolean: Need additional value from user or not? True is yes
 * - errorMessage: default error message, can be edit by the users
 *
 * ⛔ THIS OBJECT IS THE SINGLE SOURCE OF TRUTH FOR WHICH RULE TYPES EXIST.
 * Adding a key here is not enough on its own — a rule also needs a lowercase `case` in
 * libraries/validation.js (the engine lowercases ruleType before switching, and an
 * unknown type THROWS out of the whole submit-time run). Both halves are pinned by
 * cypress/node-tests/forms-format-rules.test.js ("AGREEMENT").
 */

const VALIDATION_RULES = {
    required: {
        label: "Required",
        desc: "Field must have value (at least length must be 1)",
        needValue: false,
        errorMessage: "This field is required",
    },

    min: {
        label: "Minimum",
        desc: "Minimum length of the value. For number field, it will be the value (not length)",

        needValue: true,
        valueInfo: "Number",

        errorMessage: "Minimum value for this field is :min",
    },

    max: {
        label: "Maximum",
        desc: "Maximum length of the value. For number field, it will be the value (not length)",

        needValue: true,
        valueInfo: "Number",

        errorMessage: "Maximum value for this field is :max",
    },

    isEmail: {
        label: "Is Email",
        desc: "Validate email address",
        needValue: false,
        errorMessage: "Wrong email address format",
    },

    regex: {
        label: "Regex",
        desc: "Validation the field by using your own Regex Rule",

        needValue: true,
        valueInfo: "Regex String|Flag - Eg: [0-9]+|g",

        errorMessage: "This field value doesn't match with the rule",
    },

    sameAs: {
        label: "Same As",
        desc: "Check if the field has same value with another field",

        needValue: true,
        valueInfo: "The field name you want to check with",

        errorMessage: "This field value doesn't as same as :sameAs",
    },

    customClosure: {
        label: "Custom Closure",
        desc: "Invoke your own method to check your field",

        needValue: true,
        valueInfo: "Your method name",

        errorMessage: "Custom validation failed.",
    },

    // ── Format rules ─────────────────────────────────────────────────────────
    // A FORMAT rule passes on a blank value on purpose: only `required` decides whether a
    // field must be filled. Combining the two is how an office asks for "optional, but if
    // you do type something it has to be a real phone number".
    isPhone: {
        label: "Is Phone Number",
        desc: "US/Canada phone number: 10 digits, any formatting",
        needValue: false,
        errorMessage: "Enter a valid 10-digit phone number, for example (555) 555-1234.",
    },

    isSSN: {
        label: "Is Social Security Number",
        desc: "9-digit US Social Security Number, dashes optional",
        needValue: false,
        errorMessage: "Enter a valid 9-digit Social Security Number, for example 123-45-6789.",
    }
}

/**
 * Add Validation Rule for the Control Validation
 * @param ruleType
 * @returns {{errorMessage: (string), type: (string)}}
 */
class ValidationRule {
    /**
     * Needed properties
     */
    ruleType = ""
    errorMessage = ""
    additionalValue = ""

    constructor(ruleType, customErrorMessage) {
        this.ruleType = ruleType

        if (ruleType) {
            this.errorMessage = customErrorMessage || VALIDATION_RULES[ruleType].errorMessage || ""
        }
    }
}

export
{
    VALIDATION_RULES,
    ValidationRule
}